import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { AppService } from "../../../app.service";
import { UsuariosService } from "../api/usuarios.service";
import { HttpService } from "../http/http.service";
import { StorageService } from "../storage/storage.service";
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent }
  from '@angular/common/http'
@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const authReq = req.clone({
            setHeaders: {
                'Cache-Control': 'no-cache',
                 Pragma: 'no-cache'
            }
        });
        return next.handle(authReq);    
    }
}




// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/tia-box-dev/src/app/shared/services/auth/cache.service.ts